










































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "./Loading.vue";
import SettingsCategoryTypeForm from "../settings/SettingsCategoryTypeForm.vue";

import SettingsJson from "../../shared/SettingsJson";
import CategoryTypeJson from "../../shared/CategoryTypeJson";
import { CategoryTypeType, getCategoryTypeType } from "../../shared/CategoryTypeType";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateItemImageJson, validateItemImageJsonAdd } from "../../shared/ItemImageJson";

export default Vue.extend({
  name: "CategoryTypeSelect",
  components: {
    Loading,
    SettingsCategoryTypeForm,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    data: Array as PropType<CategoryTypeJson[]>,
    selected: Array as PropType<CategoryTypeJson[]>,
    mode: String,
    categoryTypeType: String as PropType<CategoryTypeType>,
    editable: Boolean,
    disableShowAllLimit: Boolean,
    customId: {
      default: "0",
    },
    reload: Date,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      allCategoryTypes: null as CategoryTypeJson[] | null,
      details: null as CategoryTypeJson[] | null,
      searchString: "" as string,
      showAll: false as boolean,
      showAllLimit: 12 as number,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.details = this.data;

      this.loadCategoryTypes();
    },

    async loadCategoryTypes() {
      if (this.restClient != null) {
        this.allCategoryTypes = null;

        try {
          this.allCategoryTypes = await this.restClient.getCategoryTypes([this.compCategoryTypeType]);
        } catch (e) {
          alert(e.message);
        }
      }
    },

    //START set cached data

    //END set cached data

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    resetSearchString() {
      this.searchString = "";
    },

    addCategoryType(categoryType: CategoryTypeJson) {
      if (this.details == null) this.details = [];

      this.details.push(categoryType);
    },

    removeCategoryType(index: number) {
      if (this.details != null) this.details.splice(index, 1);
    },
  },

  watch: {
    data: {
      handler() {
        this.details = this.data;
      },
    },

    details: {
      handler() {
        this.$emit("change", this.details);
      },
    },

    reload: {
      handler(val, oldVal) {
        if (val != oldVal) this.init();
      },
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    compCategoryTypeType() {
      return getCategoryTypeType(this.categoryTypeType, this.settings.useGeneralCategoryTypes);
    },

    compDetailsTypes(): CategoryTypeJson[] {
      if (this.details != null) {
        return this.details;
      } else {
        return [];
      }
    },

    filteredDetailsTypes(): CategoryTypeJson[] {
      if (this.details != null) {
        var categoryTypes: CategoryTypeJson[] = this.details as CategoryTypeJson[];

        //search
        if (this.searchString != null) {
          var tokens = this.searchString
            .split(" ")
            .map((t) => t.trim().toLowerCase())
            .filter((t) => t.length > 0);

          for (var token of tokens) {
            categoryTypes = categoryTypes.filter(
              (i) => i.title.toLowerCase().includes(token) || i.type.toLowerCase().includes(token)
            );
          }
        }

        if (categoryTypes.length > 0) return categoryTypes;
      }

      return [];
    },

    filteredDetailsTypesGrouped(): { [index: string]: CategoryTypeJson[] } | null {
      if (this.details != null) {
        var categoryTypes: CategoryTypeJson[] = this.details as CategoryTypeJson[];

        //search
        if (this.searchString != null) {
          var tokens = this.searchString
            .split(" ")
            .map((t) => t.trim().toLowerCase())
            .filter((t) => t.length > 0);

          for (var token of tokens) {
            categoryTypes = categoryTypes.filter(
              (i) =>
                i.title.toLowerCase().includes(token) ||
                i.type.toLowerCase().includes(token) ||
                i.grouping.toLowerCase().includes(token)
            );
          }
        }

        if (categoryTypes.length > 0) {
          let groupedCategoryTypes: { [index: string]: CategoryTypeJson[] } = {};

          if (this.settings.useCategoryTypeGrouping) {
            for (let categoryType of categoryTypes) {
              if (groupedCategoryTypes.hasOwnProperty(categoryType.grouping)) {
                groupedCategoryTypes[categoryType.grouping].push(categoryType);
              } else {
                groupedCategoryTypes[categoryType.grouping] = [categoryType];
              }
            }
          } else {
            groupedCategoryTypes["default"] = [...categoryTypes];
          }

          groupedCategoryTypes = Object.keys(groupedCategoryTypes)
            .sort()
            .reduce<{ [index: string]: CategoryTypeJson[] }>((obj, key) => {
              obj[key] = groupedCategoryTypes[key];
              return obj;
            }, {});

          return groupedCategoryTypes;
        }
      }

      return null;
    },

    filteredCategoryTypes(): CategoryTypeJson[] {
      if (this.allCategoryTypes != null) {
        var categoryTypes: CategoryTypeJson[] = this.allCategoryTypes as CategoryTypeJson[];

        //search
        if (this.searchString != "") {
          this.showAll = true;

          var tokens = this.searchString
            .split(" ")
            .map((t) => t.trim().toLowerCase())
            .filter((t) => t.length > 0);

          for (var token of tokens) {
            categoryTypes = categoryTypes.filter(
              (i) => i.title.toLowerCase().includes(token) || i.type.toLowerCase().includes(token)
            );
          }
        }

        if (categoryTypes.length > 0) {
          if (!this.disableShowAllLimit && categoryTypes.length > this.showAllLimit && !this.showAll) {
            return categoryTypes.slice(0, this.showAllLimit);
          } else {
            return categoryTypes;
          }
        }
      }

      return [];
    },

    filteredCategoryTypesGrouped(): { [index: string]: CategoryTypeJson[] } | null {
      if (this.allCategoryTypes != null) {
        var categoryTypes: CategoryTypeJson[] = this.allCategoryTypes as CategoryTypeJson[];

        //search
        if (this.searchString != "") {
          this.showAll = true;

          var tokens = this.searchString
            .split(" ")
            .map((t) => t.trim().toLowerCase())
            .filter((t) => t.length > 0);

          for (var token of tokens) {
            categoryTypes = categoryTypes.filter(
              (i) =>
                i.title.toLowerCase().includes(token) ||
                i.type.toLowerCase().includes(token) ||
                i.grouping.toLowerCase().includes(token)
            );
          }
        }

        if (categoryTypes.length > 0) {
          if (!this.disableShowAllLimit && categoryTypes.length > this.showAllLimit && !this.showAll) {
            categoryTypes = categoryTypes.slice(0, this.showAllLimit);
          }

          let groupedCategoryTypes: { [index: string]: CategoryTypeJson[] } = {};

          if (this.settings.useCategoryTypeGrouping) {
            for (let categoryType of categoryTypes) {
              if (groupedCategoryTypes.hasOwnProperty(categoryType.grouping)) {
                groupedCategoryTypes[categoryType.grouping].push(categoryType);
              } else {
                groupedCategoryTypes[categoryType.grouping] = [categoryType];
              }
            }
          } else {
            groupedCategoryTypes["default"] = [...categoryTypes];
          }

          groupedCategoryTypes = Object.keys(groupedCategoryTypes)
            .sort()
            .reduce<{ [index: string]: CategoryTypeJson[] }>((obj, key) => {
              obj[key] = groupedCategoryTypes[key];
              return obj;
            }, {});

          return groupedCategoryTypes;
        }
      }

      return null;
    },

    filteredAddedCategoryTypes(): CategoryTypeJson[] {
      if (this.allCategoryTypes != null) {
        var categoryTypes: CategoryTypeJson[] = this.allCategoryTypes as CategoryTypeJson[];

        //search
        if (this.searchString != "") {
          this.showAll = true;

          var tokens = this.searchString
            .split(" ")
            .map((t) => t.trim().toLowerCase())
            .filter((t) => t.length > 0);

          for (var token of tokens) {
            categoryTypes = categoryTypes.filter(
              (i) => i.title.toLowerCase().includes(token) || i.type.toLowerCase().includes(token)
            );
          }
        }

        let filteredAddedCategoryTypes = categoryTypes.filter((i: CategoryTypeJson) => {
          if (!this.compDetailsTypes.find((j: CategoryTypeJson) => j.ID == i.ID)) {
            return i;
          }
        });

        if (filteredAddedCategoryTypes.length > 0) {
          if (!this.disableShowAllLimit && filteredAddedCategoryTypes.length > this.showAllLimit && !this.showAll) {
            return filteredAddedCategoryTypes.slice(0, this.showAllLimit);
          } else {
            return filteredAddedCategoryTypes;
          }
        }
      }

      return [];
    },

    filteredAddedCategoryTypesGrouped(): { [index: string]: CategoryTypeJson[] } | null {
      if (this.allCategoryTypes != null) {
        var categoryTypes: CategoryTypeJson[] = this.allCategoryTypes as CategoryTypeJson[];

        //search
        if (this.searchString != "") {
          this.showAll = true;

          var tokens = this.searchString
            .split(" ")
            .map((t) => t.trim().toLowerCase())
            .filter((t) => t.length > 0);

          for (var token of tokens) {
            categoryTypes = categoryTypes.filter(
              (i) =>
                i.title.toLowerCase().includes(token) ||
                i.type.toLowerCase().includes(token) ||
                i.grouping.toLowerCase().includes(token)
            );
          }
        }

        let filteredAddedCategoryTypes = categoryTypes.filter((i: CategoryTypeJson) => {
          if (!this.compDetailsTypes.find((j: CategoryTypeJson) => j.ID == i.ID)) {
            return i;
          }
        });

        if (filteredAddedCategoryTypes.length > 0) {
          if (!this.disableShowAllLimit && filteredAddedCategoryTypes.length > this.showAllLimit && !this.showAll) {
            filteredAddedCategoryTypes = filteredAddedCategoryTypes.slice(0, this.showAllLimit);
          }

          let groupedCategoryTypes: { [index: string]: CategoryTypeJson[] } = {};

          if (this.settings.useCategoryTypeGrouping) {
            for (let categoryType of filteredAddedCategoryTypes) {
              if (groupedCategoryTypes.hasOwnProperty(categoryType.grouping)) {
                groupedCategoryTypes[categoryType.grouping].push(categoryType);
              } else {
                groupedCategoryTypes[categoryType.grouping] = [categoryType];
              }
            }
          } else {
            groupedCategoryTypes["default"] = [...filteredAddedCategoryTypes];
          }

          groupedCategoryTypes = Object.keys(groupedCategoryTypes)
            .sort()
            .reduce<{ [index: string]: CategoryTypeJson[] }>((obj, key) => {
              obj[key] = groupedCategoryTypes[key];
              return obj;
            }, {});

          return groupedCategoryTypes;
        }
      }

      return null;
    },
  },
});
